import { render, staticRenderFns } from "./TaskUploadFileList.vue?vue&type=template&id=f56c2140"
import script from "./TaskUploadFileList.vue?vue&type=script&lang=js"
export * from "./TaskUploadFileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports